import axios from 'axios';
import { createSignedRequest } from 'utils/createSignedRequest';
import Config from 'Config';

export const createProjectRole = async (role, createSettings) => {
  const apiPath = `permission/project/${role.projectId}/roles/create-project-role`;

  const request = {
    // url: `http://localhost:3001/${apiPath}`,

    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
    body: JSON.stringify({ role, createSettings }),
    data: { role, createSettings },
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const signedRequest = await createSignedRequest(request);
  const response = await axios(signedRequest);

  return response.data;
};
